export { default } from './TooltipToReceive'
export type { TooltipToReceiveProps } from './TooltipToReceive'
